<template>
  <v-data-table dense
                :headers="headers"
                :items="lists"
                :items-per-page="100"
                :footer-props="{'items-per-page-options': [50, 100]}"
                :loading="loading">
    <template v-slot:item.name="{item: list}">
      <router-link :to="{name: `${$root.routePrefix}.mailcoach.list.edit`, params: {listID: list.id}}">
        {{ list.name }}
      </router-link>
    </template>
    <template v-slot:item.created_at="{item: list}">
      {{ list.created_at | datetime('YYYY-MM-DD h:mm a') }}
    </template>

  </v-data-table>
</template>
<script>
export default {
  name: 'email-lists-table',
  props: {
    lists: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'List',
          value: 'name',
        },
        { // MLD-5213
          text: 'Description',
          value: 'description',
        },
        {
          text: 'Active Contacts',
          value: 'subscriber_count',
          align: 'right', // MLD-7027
        },
        {
          text: 'Created',
          value: 'created_at',
          cellClass: 'text-no-wrap',
        },
      ],
    }
  }
}
</script>
